import css from './messageModal.module.scss';

import { createContext, useContext, useMemo, useState } from 'react';

import KeyBind from '../KeyBind';

type TMessageModalContext = {
  showMessage: (msg: string) => void;
  showError: (err: unknown) => void;
};

const ctx = createContext<TMessageModalContext | null>(null);
ctx.displayName = 'MessageModal';

export const useMessageModal = () => orDie(useContext(ctx));

export const MessageModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  type TState =
    | { type: 'message'; message: string }
    | { type: 'error'; error: unknown };

  const [st, setState] = useState<TState | null>(null);

  const value = useMemo((): TMessageModalContext => {
    return {
      showMessage(message: string) {
        setState({ type: 'message', message });
      },
      showError(error: unknown) {
        console.error(error);
        setState({ type: 'error', error });
      },
    };
  }, []);

  const close = () => setState(null);

  return (
    <>
      {st && (
        <div className={css.overlay} onClick={close}>
          <KeyBind kkb="Escape" onKeyDown={close} />
          <div
            className={css.panel}
            data-type={st.type}
            onClick={evt => evt.stopPropagation()}
          >
            {'message' in st ? st.message : String(st.error)}
          </div>
        </div>
      )}
      <ctx.Provider value={value}>{children}</ctx.Provider>
    </>
  );
};
